export const getCurrentTimeForApi = () => {
  return { t: Date.now() };
};
